module.exports = __webpack_public_path__ + "static/media/EnvelopeIcon.e9784f91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/contact/img/EnvelopeIcon.svg
// module id = 1121
// module chunks = 2